export default __webpack_public_path__ + "static/media/configuration.95eef38e.svg";